// extracted by mini-css-extract-plugin
export default {"shade":"styles_shade__bm+8L","dialog":"styles_dialog__ghi21","header":"styles_header__5Qx4Y","title":"styles_title__Z7p27","closeBtn":"styles_closeBtn__eMn-o"};